module.exports = __webpack_public_path__ + "static/img/home_backgroundImg2.42281cf6.png";